import React from 'react';
import './modalProgress.css';

const RegisterPromptModal = ({ open, onClose }) => {
    if (!open) return null;

    const handleRegister = () => {
        window.location.href = '/login';
    };

    return (
        <div className="progress-overlay">
            <div className="progress-card">
                <div style={{ fontSize: '48px', marginBottom: '8px' }}>&#128274;</div>
                <div className="progress-title">Create an Account</div>
                <div className="progress-label" style={{ marginTop: '12px', maxWidth: '300px', lineHeight: '1.5' }}>
                    Register to request quotes, save configurations, and access all features.
                </div>
                <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
                    <button className="progress-done-btn" onClick={handleRegister}>
                        Register Now
                    </button>
                    <button
                        className="progress-done-btn"
                        style={{ background: '#888' }}
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RegisterPromptModal;
